export default "<spec-app-type2-link-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type2-link-table>\n";